import { useMemo } from "react";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { mapRetirementPortfolioItem } from "web_myplann/Inspiration/Retirement/Mappers/mapRetirementPortfolioItem";
import type { RetirementPortfolioItem } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const useRetirementPortfolioItems = () => {
	const { data, isPending } = usePortfolioListQuery();

	const items = useMemo(
		(): RetirementPortfolioItem[] =>
			(data?.data ?? []).flatMap((item) => {
				const mapped = mapRetirementPortfolioItem(item);
				return mapped ? [mapped] : [];
			}),
		[data],
	);

	return { items, isLoaded: !isPending };
};
